__turbopack_context__.v({
  "container": "BlogPostSugestions-module-scss-module__DZtDLG__container",
  "header": "BlogPostSugestions-module-scss-module__DZtDLG__header",
  "posts": "BlogPostSugestions-module-scss-module__DZtDLG__posts",
  "pulseLink": "BlogPostSugestions-module-scss-module__DZtDLG__pulseLink",
});
